<div class="container-fluid">

  <div class="row mt-3 pt-1 pb-1 mb-1">
    <div class="col-12">
      <div class="d-flex flex-row justify-content-start">
        <div><i class="fal fa-code-merge"></i></div>
        <div
          class="d-inline-block ml-2 mr-2">{{mergeRequests ? 'Merge Requests' : 'No Merge Requests yet (or loading)'}}</div>
      </div>
    </div>
  </div>


  <ng-container *ngFor="let project of projects">
    <ng-container *ngFor="let mr of mergeRequests">
      <div *ngIf="mr['project_id'] == project.id" class="row merge-request mt-1 pt-1 pb-1">
        <div class="col-3">{{project.name_with_namespace}}</div>
        <div class="col-6">
          <a [href]="mr.web_url" target="_blank">{{mr.title}}</a>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
